module.exports = __webpack_public_path__ + "static/media/consulting.68650be9.jp2";